var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.s.contentLicenses},[_c('img',{attrs:{"src":require('../../images/license5.png')}}),_c('br'),_c('img',{attrs:{"src":require('../../images/promission2.jpeg')}}),_c('br'),_c('img',{attrs:{"src":require('../../images/ic_license_sys.jpg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }